import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, NavigationExtras, Router, RouterStateSnapshot } from '@angular/router';

import { Store } from '@ngxs/store';

import { getDataFromLocalStorage } from '../shared/helpers/other';
import { UserModel } from '../shared/models';

@Injectable()
export class AuthGuard {
  constructor(
    private store: Store,
    private router: Router,
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    const user: UserModel = getDataFromLocalStorage('user');
    const currentUser: UserModel = this.store.selectSnapshot(({ app }) => app.currentUser);
    if (currentUser || user) {
      return true;
    } else {
      const navigationExtras: NavigationExtras = {
        queryParams: {
          redirectUrl: state.url,
        },
      };
      this.router.navigate(['/login'], navigationExtras);
    }
  }
}
